var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "setting-page-content-wrapper features",
      attrs: { id: "visitor-attributes" },
    },
    [
      _vm.showModal
        ? _c(
            "Modal",
            {
              attrs: {
                "show-footer": "",
                "ok-text": _vm.$t("settings.create"),
                title: _vm.$t("settings.newVisitorProfileInformation"),
                description: _vm.$t(
                  "settings.newVisitorProfileInformationDescription"
                ),
              },
              on: {
                cancel: function ($event) {
                  _vm.showModal = false
                },
                ok: function ($event) {
                  return _vm.createVisitorAttribute()
                },
              },
            },
            [
              _c("VisitorAttributesForm", {
                on: {
                  input: function (data) {
                    return (_vm.form = data)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-header" },
        [
          _c(
            "SupsisButton",
            {
              staticClass: "add-profile-field-button",
              attrs: { primary: "" },
              on: {
                click: function ($event) {
                  _vm.showModal = true
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("settings.newAdd")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "fields" }, [
          _c(
            "div",
            { staticClass: "form" },
            [
              _c("VisitorAttributes", {
                model: {
                  value: _vm.visitorAttributes,
                  callback: function ($$v) {
                    _vm.visitorAttributes = $$v
                  },
                  expression: "visitorAttributes",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }